import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_URL}/api/login`

export let token = null

const setToken = newToken => {
  token = `Bearer ${newToken}`
}

const login = async credentials => {
  const res = await axios.post(baseUrl, credentials)
  return res.data
}

const verify = async user => {
  const res = await axios.post(`${baseUrl}/verify`, user)
  return res.data
}

// eslint-disable-next-line
export default { login, verify, setToken, token }
